module.exports = {
  prefix: 'fac',
  iconName: 'layout-text',
  icon: [
    512, 512,
    [],
    null,
    'M26.94 390.73c-14.88,0 -26.94,12.07 -26.94,26.96 0,14.87 12.06,26.94 26.94,26.94l458.12 0c14.88,0 26.94,-12.07 26.94,-26.94 0,-14.89 -12.06,-26.96 -26.94,-26.96l-458.12 0zm-26.94 -80.82c0,-14.91 12.06,-26.95 26.94,-26.95l458.12 0c14.88,0 26.94,12.04 26.94,26.95 0,14.88 -12.06,26.94 -26.94,26.94l-458.12 0c-14.88,0 -26.94,-12.06 -26.94,-26.94zm26.94 -134.75c-14.88,0 -26.94,12.07 -26.94,26.94 0,14.9 12.06,26.96 26.94,26.96l458.12 0c14.88,0 26.94,-12.06 26.94,-26.96 0,-14.87 -12.06,-26.94 -26.94,-26.94l-458.12 0zm0 -107.8c-14.88,0 -26.94,12.08 -26.94,26.95 0,14.88 12.06,26.95 26.94,26.95l458.12 0c14.88,0 26.94,-12.07 26.94,-26.95 0,-14.87 -12.06,-26.95 -26.94,-26.95l-458.12 0z'
  ]
};


// WEBPACK FOOTER //
// ./src/icons/layouts/faLayoutText.js